import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Open the Stripe Billing Portal for the logged-in user (manage/cancel subscription,
// update card, view invoices). Returns the hosted portal URL to redirect to.
export const getBillingPortalUrl = async () => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${API_BASE_URL}/payments/portal`,
    {},
    { headers: { Authorization: `${token}` } }
  );
  return response.data?.result?.url || response.data?.url;
};

// Cancel the subscription at period end, in-app. Access continues until the
// date returned as accessUntil.
export const cancelSubscription = async (reason, comment) => {
  const token = localStorage.getItem('token');
  const response = await axios.post(
    `${API_BASE_URL}/payments/cancel`,
    { reason, comment },
    { headers: { Authorization: `${token}` } }
  );
  return response.data?.result || response.data;
};

// Purchasable plans with live Stripe amounts. Anonymous endpoint — the website
// pricing page uses the same one.
export const getPlans = async (audience) => {
  const response = await axios.get(`${API_BASE_URL}/payments/plans`, {
    params: audience ? { audience } : undefined,
  });
  return response.data?.result?.plans || response.data?.plans || [];
};

export const getCancelReasons = async () => {
  const response = await axios.get(`${API_BASE_URL}/payments/cancel-reasons`);
  return response.data?.result?.reasons || response.data?.reasons || [];
};
